module.exports = __webpack_public_path__ + "img/studiopro_login_dark.8d211221.png";